// 予約フォームのモード
//   INST     : 講師から選ぶ（初期値）
//   DATETIME : 日時から選ぶ
export const PRACTICE_RESERVE_MODE = {
  INST: 'inst',
  DATETIME: 'datetime',
} as const;
export type PracticeReserveMode = typeof PRACTICE_RESERVE_MODE[keyof typeof PRACTICE_RESERVE_MODE];
